<template>
  <GuestPage>
    <div class="admin-required">
      <AppPanel>
        <div class="panel">
          <div><img class="panel__image" src="@/assets/images/logo.svg" alt="" /></div>
          <div>
            <h1 class="text text--xxl text--bold" data-cy="title">{{ $t("pages.accounts.admin_required.title") }}</h1>
            <p class="margin-v--m">{{ $t("pages.accounts.admin_required.description") }}</p>
          </div>
          <div class="panel__actions">
            <AppButton :text="$t('pages.accounts.admin_required.continue')" data-cy="backToFleebe" @onclick="goBackToFleebe" />
          </div>
        </div>
      </AppPanel>
    </div>
  </GuestPage>
</template>

<script setup lang="ts">
import AppPanel from "@/components/AppPanel.vue";
import AppButton from "@/components/AppButton.vue";
import GuestPage from "@/layout/guest/GuestPage.vue";
import router from "@/router/router";

const goBackToFleebe = () => router.push({ name: "default" });
</script>

<style scoped lang="scss">
.admin-required {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
}

.panel {
  display: grid;
  grid-column-gap: var(--space-l);
  grid-template-columns: 100px 1fr 200px;

  &__image {
    width: 100px;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
